module.exports = __webpack_public_path__ + "img/icon_x.c02e57ba.svg";